import React, { useState } from 'react';
import { ReactComponent as Eye } from '../eye.svg';
import { ReactComponent as EyeOff } from '../eye-off.svg';

function DeleteAccount() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await fetch('https://api.linkount.com/auth/deleteAccountWebsite', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        setMessage('Votre compte a été supprimé avec succès.');
        setEmail('');
        setPassword('');
      } else {
        let errText = 'Une erreur est survenue. Veuillez réessayer.';
        try {
          const data = await response.json();
          if (data && (data.message || data.error)) {
            errText = data.message || data.error;
          }
        } catch (_) {
          // ignore parse errors
        }
        setError(errText);
      }
    } catch (e) {
      setError("Impossible d'atteindre le serveur. Vérifiez votre connexion.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(225deg, #7a6a9e 0%, #8e7d9b 25%, #b0a1b6 50%, #d1c6d1 100%)',
      padding: 20,
    }}>
      <form onSubmit={handleSubmit} style={{
        width: '100%',
        maxWidth: 420,
        background: 'rgba(255, 255, 255, 0.1)',
        border: '2px solid rgba(255, 255, 255, 0.2)',
        borderRadius: 16,
        backdropFilter: 'blur(10px)',
        padding: 24,
        color: '#fff',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginTop: 0, marginBottom: 12, fontFamily: 'Poppins-Medium' }}>Supprimer mon compte</h2>
        <p style={{ marginTop: 0, marginBottom: 20, opacity: 0.9, fontFamily: 'Poppins-Medium' }}>Entrez votre email et mot de passe pour confirmer.</p>

        <label htmlFor="email" style={{ display: 'block', marginBottom: 8, fontFamily: 'Poppins-Medium' }}>Adresse email</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{
            width: '90%',
            padding: '12px 14px',
            borderRadius: 10,
            border: '1px solid rgba(255,255,255,0.3)',
            background: 'rgba(0,0,0,0.1)',
            color: '#fff',
            marginBottom: 16,
            outline: 'none'
          }}
        />

        <label htmlFor="password" style={{ display: 'block', marginBottom: 8, fontFamily: 'Poppins-Medium' }}>Mot de passe</label>
        <div style={{ width: '90%', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <input
            id="password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '12px 14px',
              borderRadius: 10,
              border: '1px solid rgba(255,255,255,0.3)',
              background: 'rgba(0,0,0,0.1)',
              color: '#fff',
              outline: 'none'
            }}
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            title={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            style={{
              width: 44,
              height: 44,
              position: 'absolute',
              right: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 10,
              border: '1px solid rgba(255,255,255,0)',
              background: 'rgba(255,255,255,0)',
              cursor: 'pointer',
            }}
          >
            {showPassword ? <Eye width={20} height={20} fill='white' stroke='white'/> : <EyeOff width={20} height={20} fill='white' stroke='white'/>}
          </button>
        </div>

        {error && (
          <div style={{ background: 'rgba(255,0,0,0.15)', border: '1px solid rgba(255,0,0,0.3)', color: '#fee', borderRadius: 8, padding: '10px 12px', marginBottom: 12 }}>{error}</div>
        )}
        {message && (
          <div style={{ background: 'rgba(0,128,0,0.15)', border: '1px solid rgba(0,128,0,0.3)', color: '#e8ffe8', borderRadius: 8, padding: '10px 12px', marginBottom: 12 }}>{message}</div>
        )}

        <button type="submit" disabled={loading} style={{
          width: '100%',
          padding: '12px 16px',
          borderRadius: 12,
          border: '2px solid rgba(255, 255, 255, 0.2)',
          background: 'rgba(255, 255, 255, 0.15)',
          color: '#fff',
          cursor: loading ? 'not-allowed' : 'pointer',
          fontFamily: 'Poppins-Medium'
        }}
        >{loading ? 'Suppression...' : 'Supprimer mon compte'}</button>
      </form>
    </div>
  );
}

export default DeleteAccount;


